import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal, Table, Col, Container, Form, FormGroup, Input, Label, ModalBody, Row } from 'reactstrap';
import { AddUserButton, CommonButton, SearchInput, SingleSelect, UserInput } from '../../../Components/CommonComponents';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { getProductList, addProduct, deleteProduct, UpdateProduct, addProductSku, getProductSkuList, updateProductSku } from '../../../constants/apiCalls';
import Pagination from "../../../Components/Pagination/Pagination";
import excelImg from '../../../images/excel.png'
import closeImg from '../../../images/modalclose.png'
import editIcon from '../../../images/editIcon.png'
import deleteIcon from '../../../images/Delete.png'
import modalclose from '../../../images/close1.png'
import swal from 'sweetalert';
import ModalService from '../../../services/ModalService';
import './index.css'
import { DashBoardTitle } from '../../../Components/Title';
import { messages } from '../../../utils/constant-messages';
import Switch from "react-switch";
import lodash from 'lodash';
import { handleErrorMessage } from '../../../utils/utils';
import DateService from '../../../services/DateService';
import { dateFormat } from '../../../constants/dateFormat';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';
import Storage from '../../../services/Storage';
import { Permissions } from '../../../constants/Permissions';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const unitArr = [
  { value: 'MT', label: 'MT' },
  { value: 'KL', label: 'KL' },
  { value: 'No.', label: 'No.' },
]

const productUnitArr = [
  { value: 'KG', label: 'KG' },
  { value: 'LITRE', label: 'LITRE' },
  { value: 'UNIT', label: 'UNIT' },
]

const skuUnitArr = [
  { value: 'KG', label: 'KG' },
  { value: 'ML', label: 'ML' },
  { value: 'GM', label: 'GM' },
  { value: 'LITRE', label: 'LITRE' },
]

const ProductList = () => {
  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer);
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.ADMIN_PRODUCT_LISTS)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getProductListPage(), [Storage.getProductListPage()]);

  const initialState = { productName: '', unit: '', productUnit: '', price: '' };
  const initialSkuState = { skuProductId: '', skuProductName: '', skuUnit: '', packagingSize: '' }

  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  const [searchQuery, setSearchQuery] = useState('');
  const [userQuery, setUserQuery] = useState('');

  // Status Filter
  const [statusVal, setStatusVal] = useState('');

  const [product, setProduct] = useState(initialState)

  const [productData, setProductData] = useState([])
  const [editId, setEditId] = useState('')

  // modal
  const [modal, setModal] = useState(false);
  const [skuModal, setSkuModal] = useState(false);
  const [skuListModal, setSkuListModal] = useState(false);

  // Switch
  const [productStatus, setProductStatus] = useState(false);

  // Sku
  const [productSku, setProductSku] = useState(initialSkuState);
  const [skuStatus, setSkuStatus] = useState(false);
  const [skuListData, setSkuListData] = useState([]);

  // Sku list modal title
  const [title, setTitle] = useState('');
  const [productId, setProductId] = useState('');

  const sendQuery = (query) => {
    setSearchQuery(query);
  };
  const delayedQuery = useCallback(
    lodash.debounce((q) => sendQuery(q), 1000),
    []
  );

  useEffect(() => {
    setIsloading(true)
    getProductsDetail()
  }, [searchQuery, page, pageSize, statusVal])

  const getProductsDetail = () => {
    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: pageSize || 10,
      status: statusVal || '',
      is_export: false,
    }
    getProductList((res) => {
      const { data, success, error } = res;
      if (success === true) {
        if (data && data.products) {
          setProductData(data.products);
        } else {
          setProductData([]);
        }
        let count = Number(data.total_records);
        setCount(count);
        let totalPages = Math.ceil(count / pageSize);
        setTotalPages(totalPages);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  const handleAddProduct = (e) => {
    setModal(!modal)
    setEditId('')
    setProduct('')
    setProductStatus(true)
  }

  const handleEdit = (elem) => {
    setModal(!modal);
    setEditId(elem.id)
    setProduct({ ...product, productName: elem.name, unit: elem.unit_type, productUnit: elem.product_unit, price: elem.price });
    setProductStatus(elem.is_active);
  }

  // modal
  const handleChangeProduct = (e) => {
    const { name, value } = e.target;
    setProduct({ ...product, [name]: value });
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      name: product.productName,
      description: '',
      unit_type: product.unit,
      // price: product.price,
      price: product.price ? parseInt(product.price.toString().replace(/[^0-9]/g, '')) : null,
      product_unit: product.productUnit,
      status: productStatus === true ? 'Active' : 'Inactive'
    }
    let editPayload = {
      name: product.productName,
      id: editId,
      status: productStatus === true ? 'Active' : 'Inactive'
    }
    if (!editId) {
      setIsloading(false);
      setIsModalLoading(true);
      addProduct((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          setModal(false);
          getProductsDetail();
        } else if (success === false || success === 'undefined') {
          getProductsDetail();
          setModal(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }

    if (editId) {
      setIsloading(false);
      setIsModalLoading(true);
      UpdateProduct((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          setModal(false);
          getProductsDetail();
        } else if (success === false || success === 'undefined') {
          getProductsDetail();
          setModal(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editPayload);
    }

  }

  const handleDelete = (id) => {
    swal({
      title: 'Delete Product',
      text: 'Are you sure, you want to delete?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((isConfirm) => {
      if (isConfirm) {
        setIsloading(true);
        let payload = {
          id: id
        }
        deleteProduct(
          (res) => {
            const { success, message, error } = res;
            if (success === true) {
              ModalService.openAlert('', message, 'success');
              setIsloading(false);
              setModal(false);
              getProductsDetail();
            } else if (success === false || success === 'undefined') {
              ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
              setIsloading(false);
              setModal(false);
            }
            setIsloading(false);
          }, payload);
      }
    });
  };

  const handleSearchChange = (e) => {
    let q = e.target.value;
    delayedQuery(q);
    setUserQuery(q);
    if (q) {
      setPage(1);
    } else {
      setPage(Number(pageNo));
    }
  };

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setProductListPage(Number(page));
    },
    [page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
    },
    [page, pageSize]
  );

  const handleStatusChange = (e) => {
    setStatusVal(e.target.value);
    setPage(1);
    Storage.setProductListPage(1);
  }

  const getSkuList = (id) => {
    let payload = {
      product_id: id
    }
    getProductSkuList((res) => {
      const { data, success, error } = res;
      if (success) {
        setSkuListData(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  const handleAddProductSku = (name, id) => {
    setSkuModal(!skuModal);
    setSkuStatus(true);
    setProductSku({ ...productSku, skuProductId: id, skuProductName: name, skuUnit: '', packagingSize: '' })
  }

  const handleChangeSKu = (e) => {
    const { name, value } = e.target;
    setProductSku({ ...productSku, [name]: value });
  }

  const handleSkuSubmit = (e) => {
    e.preventDefault();
    let payload = {
      product_id: productSku.skuProductId,
      size: productSku.packagingSize,
      unit: productSku.skuUnit,
      status: skuStatus === true ? 'Active' : 'Inactive'
    }
    setIsloading(false);
    setIsModalLoading(true);
    addProductSku((res) => {
      const { success, message, error } = res;
      if (success === true) {
        ModalService.openAlert('', message, 'success');
        setIsloading(false);
        setSkuModal(false);
        getProductsDetail();
        getSkuList(productSku.skuProductId);
      } else if (success === false || success === 'undefined') {
        getProductsDetail();
        setSkuModal(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
      setIsloading(false);
      setIsModalLoading(false);
    }, payload);
  }

  const handleSkuListModal = (elem) => {
    setTitle(elem.name);
    setProductId(elem.id);
    getSkuList(elem.id);
    setSkuListModal(!skuListModal);
  }

  // Excel sheet
  const handleExcelSheet = (page, pageSize) => {
    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: 100000,
      status: statusVal || '',
      is_export: true,
    }
    getProductList((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handleChangeSkuStatus = (e, elem) => {
    if (elem.id) {
      let index = skuListData.findIndex((e) => e.id === elem.id);
      skuListData[index].is_active = e;
      setSkuListData([...skuListData]);
    }

    let payload = {
      id: elem.id,
      status: e === true ? 'Active' : 'Inactive',
    }
    setIsloading(false);
    setIsModalLoading(true);
    updateProductSku((res) => {
      const { success, message, error } = res;
      if (success === true) {
        ModalService.openAlert('', message, 'success');
        setIsloading(false);
        setSkuModal(false);
        getProductsDetail();
        getSkuList(elem.product_id);
      } else if (success === false || success === 'undefined') {
        getProductsDetail();
        setSkuModal(false);
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
      setIsModalLoading(false);
    }, payload);
  }

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='productList'>
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Product List' className="lightTitle" />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className='searchArea'>
                        <div className='searchBlock'>
                          <div>
                            <SearchInput
                              // parentStyle={{maxWidth: '200px'}} 
                              InputProps={{
                                name: 'search',
                                placeholder: 'Search by Product Name',
                                value: userQuery
                              }}
                              onChange={handleSearchChange}
                            />
                          </div>
                          <div className='statusWrapper'>
                            <FormGroup>
                              <Label className='statusLabel'>Status</Label>
                              <div className='d-flex' onChange={handleStatusChange}>
                                <FormGroup className='d-flex align-items-center radioGroup'>
                                  <Input
                                    type='radio'
                                    name='statusRadio'
                                    defaultChecked
                                    value={''}
                                    className="m-0"
                                  />
                                  <Label className='ml-4 mb-0'>All</Label>
                                </FormGroup>
                                <FormGroup className='d-flex align-items-center radioGroup'>
                                  <Input
                                    type='radio'
                                    name='statusRadio'
                                    value={'Active'}
                                    className="m-0"
                                  />
                                  <Label className='ml-4 mb-0'>Active</Label>
                                </FormGroup>
                                <FormGroup className='d-flex align-items-center radioGroup'>
                                  <Input
                                    type='radio'
                                    name='statusRadio'
                                    value={'Inactive'}
                                    className="m-0"
                                  />
                                  <Label className='ml-4 mb-0'>Inactive</Label>
                                </FormGroup>
                              </div>
                            </FormGroup>
                          </div>
                        </div>
                        <img src={excelImg} alt="excel" width={35} height={35} className="excelIcon mr-4" onClick={() => handleExcelSheet()} />
                        <AddUserButton name='Add Product' customClass="p-0" onClick={handleAddProduct} />
                      </div>
                    </Col>
                  </Row>
                  {productData && productData.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table className='mb-0 text-center'>
                            <thead>
                              <tr>
                                <th className='text-left'>Product name</th>
                                <th>Product SKU’s</th>
                                <th>Unit</th>
                                <th>Product Unit</th>
                                <th>Price</th>
                                <th>Status</th>
                                <th>Created At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {productData.map((elem, index) => {
                                const { id, name, unit_type, price, is_active, skus, product_unit, created_at } = elem
                                return (
                                  <tr key={index}>
                                    <td className='text-left'>{name}</td>
                                    <td>
                                      <div className='blueText' onClick={() => handleSkuListModal(elem)}>{skus}</div>
                                    </td>
                                    <td>{unit_type}</td>
                                    <td>{product_unit}</td>
                                    <td>{price.toLocaleString('en-IN')} per {unit_type}</td>
                                    <td>{is_active ? 'Active' : 'Inactive'}</td>
                                    <td>{DateService.localDateOnly(created_at, dateFormat.DATE_FORMAT_3)} <br />
                                      {DateService.localDateOnly(created_at, dateFormat.TIME_FORMAT_1)}
                                    </td>
                                    <td>
                                      <div className='iconBlock'>
                                        <img src={editIcon} alt='editIcon' className='iconImg' onClick={() => handleEdit(elem)} />
                                        <img src={deleteIcon} alt='delete' className='iconImg' onClick={() => handleDelete(id)} />
                                        <div data-title={'Add Product SKU'} className='iconImg addIcon' onClick={() => handleAddProductSku(elem.name, elem.id)}>+</div>
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>

              {/* Add / Edit Product */}
              <Modal isOpen={modal} toggle={() => setModal(!modal)} centered className="ProductModal" id="ProductModal">
                {isModalLoading && <CustomSpinner />}
                <ModalBody className='p-0'>
                  <div className='ModalArea'>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <div className='modalHeading'>
                            <div className='title'>{editId ? 'Update' : 'Add'} Product</div>
                            <div className="closeButton"><img src={closeImg} alt="close" onClick={() => setModal(!modal)} /></div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleSubmit}>
                            <div className='inputWrapper'>
                              <Row>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="userName">Product Name <span className='required'>*</span></Label>
                                    <UserInput
                                      required={true}
                                      type='text'
                                      name='productName'
                                      id='productName'
                                      placeholder='Type Here'
                                      value={product.productName === null || product.productName === 'undefined' ? '' : product.productName}
                                      onChange={(e) => handleChangeProduct(e, 'productName')}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="unit">Unit <span className='required'>*</span></Label>
                                    <SingleSelect
                                      disabled={editId ? true : false}
                                      id="unit"
                                      name='unit'
                                      value={product.unit === null || product.unit === 'undefined' ? '' : product.unit}
                                      onChange={(e) => handleChangeProduct(e, 'unit')}
                                      options={unitArr}
                                      label={'label'}
                                      required={true}
                                      selectedValueKey={'value'}
                                    />
                                    <div className='commonNote'>Note: This will be use to display the Unit for Business Commitment</div>
                                  </FormGroup>
                                </Col>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="productUnit">Product Unit <span className='required'>*</span></Label>
                                    <SingleSelect
                                      disabled={editId ? true : false}
                                      id="productUnit"
                                      name='productUnit'
                                      value={product.productUnit === null || product.productUnit === 'undefined' ? '' : product.productUnit}
                                      onChange={(e) => handleChangeProduct(e, 'productUnit')}
                                      options={productUnitArr}
                                      label={'label'}
                                      required={true}
                                      selectedValueKey={'value'}
                                    />
                                    <div className='commonNote'>Note: This will be use for add/edit Business Commitment</div>
                                  </FormGroup>
                                </Col>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="price">Price <span className='required'>*</span></Label>
                                    <div className='d-flex align-items-center'>
                                      <NumericFormat
                                        className='format-number'
                                        type='text'
                                        autoComplete='off'
                                        name='price'
                                        required
                                        disabled={editId ? true : false}
                                        thousandSeparator={true}
                                        thousandsGroupStyle='lakh'
                                        value={product.price === null || product.price === 'undefined' ? '' : product.price}
                                        onChange={(e) => handleChangeProduct(e, 'price')}
                                        onKeyPress={(e) => {
                                          if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                          }
                                        }}
                                        id='price'
                                        placeholder='Type here'
                                        style={{ width: '75%' }}
                                      />
                                      <div className='ml-2'>{product.unit ? `Per ${product.unit}` : ''}</div>
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="userName">Product Status</Label>
                                    <div>
                                      <Switch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        height={30}
                                        width={70}
                                        handleDiameter={22}
                                        onColor="#545CD8"
                                        className="statusSwitch"
                                        id="statusSwitch"
                                        checked={productStatus}
                                        onChange={(e) => setProductStatus(e)}
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </div>
                            <div className='text-center'>
                              <CommonButton name={editId ? 'Update' : 'Add'} btnClass={'btnPrimary'} type="submit" />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>

              {/* Add SKU Modal */}
              <Modal isOpen={skuModal} toggle={() => setSkuModal(!skuModal)} centered className="ProductModal" id="ProductModal">
                {isModalLoading && <CustomSpinner />}
                <ModalBody className='p-0'>
                  <div className='ModalArea'>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <div className='modalHeading'>
                            <div className='title'>Add Product SKU</div>
                            <div className="closeButton"><img src={closeImg} alt="close" onClick={() => setSkuModal(!skuModal)} /></div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleSkuSubmit}>
                            <div className='inputWrapper'>
                              <Row>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="skuProductName">Product Name <span className='required'>*</span></Label>
                                    <UserInput
                                      required={true}
                                      type='text'
                                      disabled
                                      name='skuProductName'
                                      id='skuProductName'
                                      placeholder='Type Here'
                                      value={productSku.skuProductName === null || productSku.skuProductName === 'undefined' ? '' : productSku.skuProductName}
                                      onChange={(e) => handleChangeSKu(e, 'skuProductName')}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="skuUnit">SKU Unit <span className='required'>*</span></Label>
                                    <SingleSelect
                                      id="skuUnit"
                                      name='skuUnit'
                                      value={productSku.skuUnit === null || productSku.skuUnit === 'undefined' ? '' : productSku.skuUnit}
                                      onChange={(e) => handleChangeSKu(e, 'skuUnit')}
                                      options={skuUnitArr}
                                      label={'label'}
                                      required={true}
                                      selectedValueKey={'value'}
                                    />
                                    <div className='commonNote'>Note: This will be use for the order</div>
                                  </FormGroup>
                                </Col>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="packagingSize">Packaging Size <span className='required'>*</span></Label>
                                    <UserInput
                                      required={true}
                                      type='text'
                                      name='packagingSize'
                                      id='packagingSize'
                                      placeholder='Type Here'
                                      value={productSku.packagingSize === null || productSku.packagingSize === 'undefined' ? '' : productSku.packagingSize}
                                      onChange={(e) => handleChangeSKu(e, 'packagingSize')}
                                      // onKeyPress={(e) => {
                                      //   if (!/[0-9]/.test(e.key)) {
                                      //     e.preventDefault();
                                      //   }
                                      // }}
                                      onKeyPress={(e) => {
                                        let regex = /^[0-9.\b]+$/;
                                        if (!regex.test(e.key)) {
                                          e.preventDefault();
                                        }
                                        let splitDot =
                                          e.target.value && e.target.value.includes('.')
                                            ? e.target.value.split('.')
                                            : [];
                                        if (splitDot.length > 1 && e.key === '.') {
                                          // only 1 dot
                                          e.preventDefault();
                                        }

                                        if (
                                          splitDot &&
                                          splitDot.length > 1 &&
                                          splitDot[1].length > 2
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col lg={6}>
                                  <FormGroup>
                                    <Label for="userName">SKU Status</Label>
                                    <div>
                                      <Switch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        height={30}
                                        width={70}
                                        handleDiameter={22}
                                        onColor="#545CD8"
                                        className="skustatusSwitch"
                                        id="skustatusSwitch"
                                        checked={skuStatus}
                                        onChange={(e) => setSkuStatus(e)}
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </div>
                            <div className='text-center'>
                              <CommonButton name={'Add'} btnClass={'btnPrimary'} type="submit" />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>

              {/* Sku list modal */}
              <Modal isOpen={skuListModal} toggle={() => setSkuListModal(!skuListModal)} centered className="skuListModal" id="skuListModal">
                <ModalBody className='p-0'>
                  <div className='modalHeading mb-0'>
                    <div className='title'>SKU List for {title}</div>
                    <div className="closeButton"><img src={modalclose} alt="close" onClick={() => setSkuListModal(!skuListModal)} /></div>
                  </div>
                  <Container>
                    <Row>
                      <Col xs={12}>
                        <AddUserButton name="Add Product SKU" customClass="skuButton" onClick={() => handleAddProductSku(title, productId)} />
                      </Col>
                    </Row>
                    {skuListData && skuListData.length > 0 ? (
                      <div>
                        <Row>
                          <Col xs={12}>
                            <div className='table-responsive skuTable'>
                              <Table bordered className='table text-center'>
                                <thead>
                                  <tr className='headingRow'>
                                    <th>SKU Unit</th>
                                    <th>Packaging Size</th>
                                    <th>SKU Status</th>
                                    <th>Created At</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {skuListData.map((elem, index) => {
                                    const { unit, size, created_at, is_active } = elem;
                                    return (
                                      <tr key={index}>
                                        <td>{unit}</td>
                                        <td>{size}</td>
                                        <td>
                                          <Switch
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            height={21}
                                            width={50}
                                            handleDiameter={15}
                                            onColor="#545CD8"
                                            className="skuStatusSwitch"
                                            id="skuStatusSwitch"
                                            checked={is_active}
                                            onChange={(e) => { handleChangeSkuStatus(e, elem) }}
                                          />
                                        </td>
                                        <td>
                                          {DateService.localDateOnly(created_at, dateFormat.DATE_FORMAT_3)} <br />
                                          {DateService.localDateOnly(created_at, dateFormat.TIME_FORMAT_1)}
                                        </td>
                                      </tr>
                                    )
                                  })}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ) : ''}
                  </Container>
                </ModalBody>
              </Modal>
              {isLoading && <CustomSpinner />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default ProductList;